export const issueReportFormFields = {
  hasConversionChange: {
    name: 'hasConversionChange',
    label: 'Have you seen a change in the conversion metrics?',
  },
  conversionChangeAt: {
    name: 'conversionChangeAt',
    label: 'When did conversion change?',
    options: [
      { label: 'Select', value: null },
      { label: 'Within last week', value: 'week' },
      { label: 'Within last month', value: 'month' },
      { label: 'Over a month ago', value: 'over_month' },
      { label: 'Different period', value: 'different_period' },
    ],
  },
  conversionChangeAmount: {
    name: 'conversionChangeAmount',
    label: 'Approximately, by how much did the conversion change by?',
    options: [
      { label: 'Select', value: null },
      { label: '10%', value: '10' },
      { label: '20%', value: '20' },
      { label: '30% or more', value: '30_plus' },
    ],
  },
  conversionChangeType: {
    name: 'conversionChangeType',
    label: 'What type of conversion change?',
    options: [
      { label: 'Select', value: null },
      { label: 'Click to sale', value: 'click_to_sale' },
      { label: 'Loyalty: queries to transaction rate', value: 'loyalty' },
    ],
  },
  comment: {
    name: 'comment',
    label: 'Please explain the issue',
  },
  shouldEmailOtherPublishers: {
    name: 'shouldEmailOtherPublishers',
    label: 'Would you like Moonpull to contact other relevant publishers?',
  }
}